/**
 * Shop Pay Button Visibility Fix
 * Ensures Buy with Shop Pay button is visible and properly initialized
 */

(function() {
  'use strict';

  function ensureShopPayButtonVisible() {
    // Find all Shop Pay button containers
    const paymentButtons = document.querySelectorAll('.shopify-payment-button');
    
    paymentButtons.forEach(function(button) {
      // Remove any inline styles that might hide the button
      if (button.style.display === 'none') {
        button.style.display = 'block';
      }
      
      // Ensure visibility
      button.style.visibility = 'visible';
      button.style.opacity = '1';
      
      // Check if button is actually rendered by Shopify
      const shopPayButton = button.querySelector('.shopify-payment-button__button');
      if (shopPayButton) {
        shopPayButton.style.display = 'block';
        shopPayButton.style.visibility = 'visible';
        shopPayButton.style.opacity = '1';
      }
    });
  }

  // Run immediately if DOM is ready, otherwise on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureShopPayButtonVisible);
  } else {
    ensureShopPayButtonVisible();
  }

  // Run after a shorter delay to catch dynamically loaded buttons (reduced from 1000ms to 100ms)
  setTimeout(ensureShopPayButtonVisible, 100);
  
  // Also check when Shopify's payment buttons are initialized
  if (window.Shopify && window.Shopify.dynamicPaymentButtons) {
    // If Shopify's payment button API is available, use it
    const originalInit = window.Shopify.dynamicPaymentButtons.init;
    if (originalInit) {
      window.Shopify.dynamicPaymentButtons.init = function() {
        const result = originalInit.apply(this, arguments);
        setTimeout(ensureShopPayButtonVisible, 50);
        return result;
      };
    }
  }
  
  // Watch for dynamically added payment buttons (e.g., when variant changes)
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.classList.contains('shopify-payment-button') ||
            node.querySelector('.shopify-payment-button')
          )) {
            shouldCheck = true;
          }
        });
      }
    });
    
    if (shouldCheck) {
      // Use requestAnimationFrame for faster response
      requestAnimationFrame(function() {
        ensureShopPayButtonVisible();
      });
    }
  });

  // Observe the document body for changes
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Re-check when variant changes
  document.addEventListener('variant:change', ensureShopPayButtonVisible);
  document.addEventListener('variant:change:end', ensureShopPayButtonVisible);
  
  // Also listen for custom variant change events
  window.addEventListener('t4s:variant:change', ensureShopPayButtonVisible);
})();

